module.exports = __webpack_public_path__ + "static/media/SF-1-A.028025a8.mp3";